class CfopCreditoController extends AbstractController
  @$inject = ['$injector', 'pathService', 'cfopCreditoService']

  constructor: ($injector, pathService, @cfopCreditoService) ->
    super($injector)

    url = pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/cfop-credito/'
    @modalCfopCredito = @openPopup(url + 'modal.html', 'cfopCreditoModalController as ctrl', null, 'static')

    @modalImportCfop = @openPopup(pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/cfop-credito/importar.html',
      'cfopImportModalController as ctrl')

    @loadingTracker = @promiseTracker()
    @list()

  importar: () ->
    @modalImportCfop({}, (result) =>
      @list() if result.ok
    )

  list: () ->
    @loadingTracker.addPromise(
      @cfopCreditoService.getList((data) =>
        data.each (cfopCredito) =>
          if cfopCredito.cfopsSaida
            cfopCredito.cfopsSaida.sort (a, b) => a - b

        @listOfCfopCredito = data
      )
    )

  abrirModel: (cfopCredito) ->
    @modalCfopCredito({
      cfopCredito: ->
        angular.copy cfopCredito
    }, (result) =>
      @list())

  adicionar: () ->
    @abrirModel()

  editar: (item) ->
    cfopCredito = angular.copy item
    cfopCredito.dataInicioEscrituracao = if cfopCredito.dataInicioEscrituracao then new Date(cfopCredito.dataInicioEscrituracao) else null
    cfopCredito.dataFimEscrituracao = if cfopCredito.dataFimEscrituracao then new Date(cfopCredito.dataFimEscrituracao) else null
    @abrirModel(cfopCredito)

  remover: (cfopCredito) ->
    @Confirm.warning("Atenção!",
      "Deseja realmente remover a CFOP geradora de crédito <strong>#{cfopCredito.descricao}</strong>? Essa ação não poderá ser desfeita.", {
        'Sim': =>
          @cfopCreditoService.delete(cfopCredito.id, =>
            Alert.success("CFOP geradora de crédito <strong>#{cfopCredito.descricao}</strong> removida com sucesso.")
            @list()
          )
        'Não': null
      })

angular.module("eficienciaFiscalModule").controller('cfopCreditoController', CfopCreditoController)

class CfopCreditoModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'cfopCreditoService', 'tabelaService', 'cfopCredito']

  constructor: ($injector, @modalInstance, @cfopCreditoService, tabelaService, cfopCredito) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @cfopCredito = { descricao: '', cfopsSaida: []}

    @listOfTabela = @lazyLoad('eficienciaFiscal->configuracao->tabelaService', (loaded)=>
      tabelaService.getList((data) =>
        loaded data
      )
    )

    @cfopCredito = cfopCredito if cfopCredito
    @cfopCredito.cfopsSaida = if @cfopCredito.cfopsSaida then @cfopCredito.cfopsSaida else []

  salvar: (form, data) ->
    if form.$valid
      @submitTracker.addPromise(
        @cfopCreditoService.save(angular.copy(data), (result) =>
          if result.success
            @Alert.success("CFOP geradora de crédito <strong>#{data.descricao}</strong> adicionada.", 'Sucesso')
            @modalInstance.close()
        )
      ) unless data.id
      @submitTracker.addPromise(
        @cfopCreditoService.update(angular.copy(data), (result) =>
          @Alert.success("CFOP geradora de crédito <strong>#{data.descricao}</strong> atualizado.", 'Sucesso')
          @modalInstance.close()
        )
      ) if data.id


angular.module("eficienciaFiscalModule").controller('cfopCreditoModalController', CfopCreditoModalController)

class CfopImportModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'FileUploader']

  constructor: ($injector, @modalInstance, FileUploader) ->
    super($injector)

    @uploader = new FileUploader(
      url: '/api/eficiencia-fiscal/cfop-credito'
      headers: cbk.getHeaders()
      formData: []
    )

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>
      @modalInstance.close(new Retorno(true))

  importar: ->
    @uploader.uploadAll()

angular.module("eficienciaFiscalModule").controller('cfopImportModalController', CfopImportModalController)